import { create } from 'zustand';
import { ApiUtils, RequestStrategyEnum } from '@shared/utils';
import { AuthApi, type RegisterRequestStore } from '@shared/api';

interface RegisterType {
  registerDone: string | null;
  loading: boolean;
  error: string | null;
  register: (request: RegisterRequestStore, signal?: AbortSignal) => Promise<void>;
  resetErrors: () => void;
  clear: () => void;
}

export const useRegisterStore = create<RegisterType>((set) => ({
  registerDone: null,
  error: null,
  loading: false,

  register: ApiUtils.wrapperApi(async (request, signal) => {
    try {
      set({ registerDone: null, loading: true, error: null });
      const result = await AuthApi.register(request, signal);
      set({ registerDone: result, loading: false });
    } catch (error) {
      set({ registerDone: null, loading: false, error: ApiUtils.getApiError(error) });
    }
  }, RequestStrategyEnum.Debounce),

  resetErrors: () => set({ error: null }),

  clear: () => set({ registerDone: null, error: null, loading: false }),
}));
